import CommonTable from "@/components/commonTable";
import { calibrateLaxianMotorRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderWireMotorCalibrationStatus } from "./status";

interface CalibrateTableWireMotorProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableWireMotor = (props: CalibrateTableWireMotorProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);



    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateLaxianMotorRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime'
        },
        {
            title: '参数版本号',
            dataIndex: 'version'
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            render: renderWireMotorCalibrationStatus
        },
        {
            title: 'C3',
            dataIndex: 'c3'
        },
        {
            title: 'C2',
            dataIndex: 'c2'
        },
        {
            title: 'C1',
            dataIndex: 'c1'
        },
        {
            title: 'C0',
            dataIndex: 'c0'
        },
        {
            title: '静态标定: 空行程',
            dataIndex: 'pedalIdleTravel'
        },
        {
            title: '静态标定: 最大行程',
            dataIndex: 'pedalMaxTravel'
        },
        {
            title: '静态标定-x^1系数',
            dataIndex: 'staticC1'
        },
        {
            title: '静态标定-常数项系数',
            dataIndex: 'staticC0'
        }
    ] ;

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: '100%', y: 400 }}
        />
    );
};

export default CalibrateTableWireMotor;
